/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable nonblock-statement-body-position */
/* eslint-disable indent */
/* eslint-disable react/no-deprecated */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint-disable max-classes-per-file */

import React from 'react';
import { Popup } from 'react-map-gl';
import TimeWithTimezone from 'components/TimeWithTimezone';

const StopToolTip = (props) => {
  const { hoverStop, assignmentTimezone, onClose } = props;
  const isDropoff = hoverStop && hoverStop.type === 'DROP_OFF';
  const timezone = assignmentTimezone || hoverStop?.shipment?.timezone;
  return (
    hoverStop && (
      <Popup
        closeButton={false}
        longitude={isDropoff ? hoverStop.shipment.dropoff_address.lng : hoverStop.shipment.pickup_address.lng}
        latitude={isDropoff ? hoverStop.shipment.dropoff_address.lat : hoverStop.shipment.pickup_address.lat}
        closeOnClick
        offset={30}
        className={'map-tooltip'}
        onClose={onClose}
        style={{ zIndex: 10 }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0px', minWidth: '140px', margin: 0 }}>
          <TimeWithTimezone variant="tooltip" label="ETA" timeTs={hoverStop.estimated_arrival_ts} timezone={timezone} sx={{ flexDirection: 'row', alignItems: 'baseline' }} />
          {hoverStop.actual_departure_ts && (
            <TimeWithTimezone variant="tooltip" label="Actual Dropoff" timeTs={hoverStop.actual_departure_ts} timezone={timezone} sx={{ flexDirection: 'row', alignItems: 'baseline' }} />
          )}
        </div>
      </Popup>
    )
  );
};

export default React.memo(StopToolTip);
